export default __webpack_public_path__ + "static/media/pendente.ecd864d7.svg";